import { __awaiter, __generator } from "tslib";
import { compKey } from './key';
export var createProfileDriver = function (wrapper) {
    var base = wrapper.$("." + compKey);
    return {
        getProfileTitle: function () { return base.$('.profile-title').text(); },
        getProfileSubtitle: function () { return base.$('.profile-subtitle').text(); },
        getSubtitleChild: function (childClassName) { return base.$(".profile-subtitle").$("." + childClassName).text(); },
        getProfileImgUrl: function () { return __awaiter(void 0, void 0, void 0, function () { return __generator(this, function (_a) {
            switch (_a.label) {
                case 0: return [4 /*yield*/, base.$('img').attr('src')];
                case 1: return [2 /*return*/, (_a.sent()) || ''];
            }
        }); }); },
        base: base
    };
};
//# sourceMappingURL=driver.js.map